import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Projects
export const getProjects = () => api.get('/projects');
export const getProject = (id) => api.get(`/projects/${id}`);
export const createProject = (data) => api.post('/projects', data);
export const updateProject = (id, data) => api.put(`/projects/${id}`, data);
export const deleteProject = (id) => api.delete(`/projects/${id}`);
export const addCollaborator = (projectId, email) => api.post(`/projects/${projectId}/collaborators`, { email });
export const removeCollaborator = (projectId, email) => api.delete(`/projects/${projectId}/collaborators/${email}`);

// Balance Sheets
export const getBalanceSheets = (projectId) => api.get(`/balance-sheets/${projectId}`);
export const createBalanceSheet = (data) => api.post('/balance-sheets', data);
export const updateBalanceSheet = (id, data) => api.put(`/balance-sheets/${id}`, data);
export const deleteBalanceSheet = (id) => api.delete(`/balance-sheets/${id}`);

// Business Plans
export const getBusinessPlans = (projectId) => api.get(`/business-plans/${projectId}`);
export const getBusinessPlan = (id) => api.get(`/business-plans/detail/${id}`);
export const createBusinessPlan = (data) => api.post('/business-plans', data);
export const updateBusinessPlan = (id, data) => api.put(`/business-plans/${id}`, data);
export const deleteBusinessPlan = (id) => api.delete(`/business-plans/${id}`);

// Project Financing
export const getProjectFinancings = (projectId) => api.get(`/project-financing/${projectId}`);
export const createProjectFinancing = (data) => api.post('/project-financing', data);
export const updateProjectFinancing = (id, data) => api.put(`/project-financing/${id}`, data);
export const deleteProjectFinancing = (id) => api.delete(`/project-financing/${id}`);

// Valuations
export const getValuations = (projectId) => api.get(`/valuations/${projectId}`);
export const createValuation = (data) => api.post('/valuations', data);
export const deleteValuation = (id) => api.delete(`/valuations/${id}`);

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');

// Export
export const exportPdf = (projectId) => api.get(`/export/pdf/${projectId}`, { responseType: 'blob' });
export const exportExcel = (projectId) => api.get(`/export/excel/${projectId}`, { responseType: 'blob' });
export const exportWord = (projectId) => api.get(`/export/word/${projectId}`, { responseType: 'blob' });

export default api;
